<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-user"></i> Users
      </Tab>
      <Tab tabid="tab-2">
        <i class="far fa-archive"></i> Archived
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable :columns="columnList" :url="dataURL" :displayTools="true" @rowClick="userClicked" :displayExportTools="true" exportTitle="Users" :displayLocationFilter="true">
          <template v-slot:title>
            <h3>User List</h3>
          </template>
          <template v-slot:tools>
            <LinkButton type="new" href="/users/new" v-if="userHasCreatePermission(PermissionTypes.UserPermissionTypes.user)" sizeClass="btn"> New User</LinkButton>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkUser :name="row.data.name" :id="row.data.id" :newTab="false" />
                <LabelBadge v-if="row.data.isOwner" labelClass=" label-success">Account Owner</LabelBadge>
              </td>
              <td>{{row.data.email}}</td>
              <td>
                <LabelAccountLocationBadge :accountLocation="row.data.accountLocation" />
              </td>
              <td>
                <span 
                  v-for="group in row.data.userGroups"
                  :key="group.id"
                  class="label label-primary mr-1"
                  :style="stylesForGroup(group)">
                  {{group.name}}
                </span>
              </td>
            </tr>
          </template>
        </DataTable>
      </TabPage>

      <TabPage tabid="tab-2">
        <DataTable :columns="columnList" :url="archivedDataURL" @rowClick="userClicked" :displayExportTools="true" exportTitle="Archived Users" :displayLocationFilter="true">
          <template v-slot:title>
            <h3>Archived User List</h3>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkUser :name="row.data.name" :id="row.data.id" :newTab="false" />
                <LabelBadge v-if="row.data.isOwner" labelClass=" label-success">Account Owner</LabelBadge>
              </td>
              <td>{{row.data.email}}</td>
              <td>
                <LabelAccountLocationBadge :accountLocation="row.data.accountLocation" />
              </td>
              <td>
                <span 
                  v-for="group in row.data.userGroups"
                  :key="group.id"
                  class="label label-primary mr-1"
                  :style="stylesForGroup(group)">
                  {{group.name}}
                </span>
              </td>
            </tr>
          </template>
        </DataTable>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"
import ColourMixin from '@/mixins/colour'

export default {
  name: "UserList",
  mixins: [ColourMixin],
  components: {
    TabbedBox,
    Tab,
    TabPage
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
      }
      return 'users?' + $.param(params)
    },
    archivedDataURL() {
      var params = {
        isActive: 0
      }
      return 'users?' + $.param(params)
    }
  },
  data: () => {
    return {
      breadcrumbs: [
          { title: 'Users', link: '/users'}
      ],
      columnList: [
        { title: "Name", data: "name", },
        { title: "Email", data: "email" },
        { title: "Account Location", data: "accountLocation.name" },
        { title: "User Groups", data: "userGroups.name" }
      ]
    }
  },
  methods: {
    userClicked(rowId) {
      this.$router.push(`/users/${rowId}`)
    },
    stylesForGroup(group) {
      return {
        'background-color': group.colourTag,
        'color': this.textColourForBackground(group.colourTag)
      }
    }
  }
};
</script>
